import React from 'react'
import './PickerSet.scss'

const PickerSet = ({ label, children }) => {

  return (
    <div className='viso-color-picker-set'>
      <div className='viso-color-picker-set__label'>{label}</div>
      <div className='viso-color-picker-set__content'>{children}</div>
    </div>
  )
}

export default PickerSet